import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  card: {
    marginBottom: 1,
  },
  cardBtn: {
    textTransform:'none !important',
    textAlign:'left !important',
    backgroundColor: 'transparent !important',
    fontSize: '14px !important',
    color:'#333333 !important',
  },
  cardHeading: {
    textTransform:'none !important',
    fontSize: '14px !important', 
    color: '#22436e !important', 
    fontWeight:'bold !important', 
    backgroundColor: 'transparent !important',
  },
  viewAllBtn: {
    textTransform:'none !important',
    textAlign:'left !important',
    backgroundColor: 'transparent !important',
    fontSize: '12px !important',
    color:'#333333 !important',
    marginRight:'-8px !important',
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


const CustomizedDialogs = React.forwardRef((props, ref) => {
  const css = useStyles();
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));

  const [open, setOpen] = React.useState(false);

  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);

  const [pageLoading, setPageLoading] = React.useState(false);
  const [btnLoading, setBtnLoading] = React.useState(false);
  const [topics, setTopics] = React.useState([]);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  var vertical='top',horizontal='center';

	function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {
    if(open){
		  getApiDataWebTopicCourses();
    }
	}, [open]);

	async function getApiDataWebTopicCourses(){
		///alert("getApiDataFilter");
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed'
				}
			};
      setPageLoading(true);
			///let selectedTopicId=31;
			axios.get(API_URL+'/app/web-topic-courses?websiteId=1&topicId='+props.topicId, axiosHeader)
			   .then(response => {
				setPageLoading(false);
				if(response.data && response.data.responseTxt==='success'){          
					setTopics(response.data?.obj);
			  }
			})
	}

  
  function selectCourse(courseId){
///alert("loginId===>> "+etlStudentObj.loginId);
		if(courseId && courseId>0){			
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};		  
            
      setBtnLoading(true);
      
			const data = new FormData(); 
			data.append('courseId', courseId);

			axios.post(API_URL+'/add-course-toguest', data, axiosHeader)
			.then((response) => {
        ///setBtnLoading(false);
				///document.writeln("RESPONSE RECEIVED: ", JSON.stringify(response)); 

				if(response && response.data && response.data.responseTxt==="success"){					

          //submit test now ................        
          if(response.data?.obj && response.data?.obj.length>0){
            //Selected courses
            localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj));
            props.submitTest(response.data.obj[0].courseId,response.data.obj[0].templateId,etlStudentObj.loginId,etlStudentObj.token);        
          }

					return false;

				}else{					
					setShowAlert(true);
					setAlertMessage("Something wrong somewhere");			
					return false;

				}
			})
			.catch((error) => {
				//console.log("AXIOS ERROR: ", error);
			})
		}  
	}

  
  return (
    <>
      {/* <Button title={"Save "+testTypeLabel+" & Exit"} onClick={handleClickOpen} variant="contained" color="primary" >Save & Exit</Button> */}
      <Dialog fullWidth onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle onClose={handleClose}>
          {!window.navigator.onLine?<span style={{color:'#FF0000'}}>Alert</span>:<>Select your course</>} 
        </DialogTitle>
        {pageLoading?<LinearProgress />:null}
        <DialogContent dividers>
            <div>
              {!window.navigator.onLine?
              <p style={{color:'#FF0000',fontWeight:'bold',minHeight:60, padding: 20}}>
                It seems, you are not connected to the internet.
              </p>
              :
              <>
              <Box>
                <Grid container spacing={2}>
                {btnLoading?
                  <Grid item md={12} xs={12}>
                    <div style={{textAlign:'center',height:130}} >
                      <CircularProgress color="inherit" /> 
                      <br/>
                      Wait...
                    </div>
                  </Grid>
                :<>
                 {(topics && topics.length>0)?<>
                  {(topics || []).map((obj,i)=>(
                    <Grid item md={4} xs={12}>
                      <Card key={'c'+i} className={css.card} style={{cursor:'pointer'}} onClick={()=>{selectCourse(obj.courseId)}} >
                      <CardContent>
                        <Box style={{marginBottom:-18}}>
                          <Grid container spacing={1} >
                            <Grid item xs={12} >
                              <Button className={css.cardBtn} onClick={()=>{selectCourse(obj.courseId)}} >{obj.courseTitle}</Button>
                            </Grid>
                          </Grid>
                        </Box> 
                      </CardContent>
                      </Card>
                    </Grid>
                    // <Button onClick={() => { selectCourse(obj.courseId) }} variant="contained" style={{backgroundColor:'#008000',color:'#FFFFFF'}} >{obj.courseTitle}</Button>
                  ))}
                 </>:null}
                 </>
                }
                </Grid>
              </Box>
                           
              {/* <Button onClick={() => { backToSelectTest() }} style={{marginRight:20}} size="small" variant="outlined" >Cancel Test</Button> */}
              </>
              }
            </div>
        </DialogContent>

        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

      </Dialog>
    </>
  );

});

export default CustomizedDialogs;
